import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faUserFriends, faArrowsAltV } from "@fortawesome/free-solid-svg-icons";
import GoogleMap from "../GoogleMap/GoogleMap";

function SearchResult(props) {
  console.log(props.vehicle);
  const { type, image, price, parson, from, to } = props.vehicle;
  return (
    <React.Fragment>
      <div className="col-md-4 input">
        <div className="">
          <div className=""></div>
          <div className="">
            <h4>{from}</h4>
            <FontAwesomeIcon icon={faArrowsAltV} />
            <h4>{to}</h4>
          </div>
        </div>
        <div className="d-flex justify-content-between">
          <img
            style={{ width: "50px", height: "40px" }}
            src={image}
            alt=""
            srcset=""
          />
          <h5 style={{ textTransform: "uppercase" }}>{type}</h5>
          <h5>
            <FontAwesomeIcon icon={faUserFriends} /> {parson}
          </h5>
          <h4>${price}</h4>
        </div>
        <div className="d-flex justify-content-between">
          <img
            style={{ width: "50px", height: "40px" }}
            src={image}
            alt=""
            srcset=""
          />
          <h5 style={{ textTransform: "uppercase" }}>{type}</h5>
          <h5>
            <FontAwesomeIcon icon={faUserFriends} /> {parson}
          </h5>
          <h4>${price}</h4>
        </div>
        <div className="d-flex justify-content-between">
          <img
            style={{ width: "50px", height: "40px" }}
            src={image}
            alt=""
            srcset=""
          />
          <h5 style={{ textTransform: "uppercase" }}>{type}</h5>
          <h5>
            <FontAwesomeIcon icon={faUserFriends} /> {parson}
          </h5>
          <h4>${price}</h4>
        </div>
        <div className="col-md-8">
          <GoogleMap></GoogleMap>
        </div>
      </div>
    </React.Fragment>
  );
}

export default SearchResult;
